import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import { userPublicProfilePath } from '../../lib/userProfileLink'
import styles from './UserRow.module.scss'


export default function UserRow({ user, children }) {
  if (!user?.id) return null

  const profilePath = userPublicProfilePath(user)
  const avatarSrc =
    user.media_attachment?.direct_upload_url ??
    user.media_attachment?.thumbnail_url ??
    '/images/default-user.png'
  const nick = user.nickname != null && String(user.nickname).trim() !== '' ? String(user.nickname).trim() : null

  const main = (
    <>
      <img className={styles.avatar} src={avatarSrc} alt="" />
      <div className={styles.details}>
        <span className={styles.name}>{user.name || '—'}</span>
        {nick != null && <span className={styles.nickname}>@{nick.replace(/^@/, '')}</span>}
      </div>
    </>
  )

  return (
    <div className={styles.row}>
      {profilePath ? (
        <Link to={profilePath} className={styles.mainLink}>
          {main}
        </Link>
      ) : (
        <div className={styles.mainStatic}>{main}</div>
      )}
      {children != null && children !== false && <div className={styles.actions}>{children}</div>}
    </div>
  )
}

UserRow.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    nickname: PropTypes.string,
    media_attachment: PropTypes.object,
  }),
  children: PropTypes.node,
}
